exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manager-card {\n  display: grid;\n  grid-template-columns: 2fr 4fr 1fr;\n  width: 100%;\n}\n.manager-card-name {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  font-size: 18px;\n  font-weight: 400;\n  color: #000000;\n  padding: 22px;\n}\n.manager-card-regions {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-grow: 2;\n  font-size: 18px;\n  font-weight: 400;\n  padding: 16px;\n  color: #000000;\n}\n.manager-card-edit {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 16px;\n  flex-grow: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Managers/components/ManagerCard/ManagerCard.less
// module id = 1207
// module chunks = 0